import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { TranslocoDirective, TranslocoService } from "@jsverse/transloco";
import { OverlayLayoutComponent } from "@m19-board/overlay/overlay-layout/overlay-layout.component";
import { OverlayRule } from "@m19-board/overlay/overlay-service/overlay-rules";
import { formatKeywordRankingMarketplaces } from "@m19-board/tracking/KeywordRankingAvailability";
import { map } from "rxjs";

@Component({
  selector: "app-share-of-voice-not-supported-overlay",
  imports: [TranslocoDirective, OverlayLayoutComponent],
  template: `
    <app-overlay-layout *transloco="let t" variant="info" [title]="t('overlays.share_of_voice_not_supported_title')">
      <p overlayBody>{{ t("overlays.share_of_voice_not_supported_reason") }}</p>
      <p overlayBody>{{ t("overlays.share_of_voice_not_supported_marketplaces", [marketplaces()]) }}</p>
    </app-overlay-layout>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShareOfVoiceNotSupportedOverlayComponent {
  private readonly translocoService = inject(TranslocoService);

  static readonly rule = OverlayRule.SHARE_OF_VOICE_NOT_SUPPORTED;

  protected readonly marketplaces = toSignal(
    this.translocoService.langChanges$.pipe(map(formatKeywordRankingMarketplaces)),
  );
}
